export default __webpack_public_path__ + "fonts/poppins-latin-900-normal.7b1a4c85ba657964c6b6.woff2";